import { render } from "./SystemStatusBanner.vue?vue&type=template&id=045ca205&scoped=true"
import script from "./SystemStatusBanner.vue?vue&type=script&lang=js"
export * from "./SystemStatusBanner.vue?vue&type=script&lang=js"

import "./SystemStatusBanner.vue?vue&type=style&index=0&id=045ca205&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045ca205"]])

export default __exports__